import { render, staticRenderFns } from "./StoryTechnicalReviewEdit.vue?vue&type=template&id=1dd7fb90&scoped=true"
import script from "./StoryTechnicalReviewEdit.vue?vue&type=script&lang=js"
export * from "./StoryTechnicalReviewEdit.vue?vue&type=script&lang=js"
import style0 from "./StoryTechnicalReviewEdit.vue?vue&type=style&index=0&id=1dd7fb90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd7fb90",
  null
  
)

export default component.exports